"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegalCapacity = exports.PlannedMonthlyTurnover = exports.PurposeOfRelationShip = exports.IncomeType = exports.Activity = exports.Education = exports.CompanyLegalFormLT = exports.CompanyLegalFormLV = exports.CompanyLegalFormEE = exports.LegalCustomerDocumentTypeCode = exports.IdDocumentTypeCode = exports.IdDocumentStatusCode = exports.ActivityCode = exports.RelationTypeCode = exports.ProceedingStatusCode = exports.ProceedingTypeCode = exports.SegmentGroupCode = exports.CommunicationTypeCode = exports.CommunicationChannelStatus = exports.CustomerStatusCode = exports.IdentificationMethod = exports.MarketingConsent = exports.LegalPrivateCode = exports.AddressTypeCode = exports.GenderCode = void 0;
var GenderCode;
(function (GenderCode) {
    GenderCode["FEMALE"] = "FEMALE";
    GenderCode["MALE"] = "MALE";
    GenderCode["UNKNOWN"] = "UNKNOWN";
})(GenderCode || (exports.GenderCode = GenderCode = {}));
var AddressTypeCode;
(function (AddressTypeCode) {
    AddressTypeCode["CONT"] = "CONT";
    AddressTypeCode["REG"] = "REG";
    AddressTypeCode["UNMAPPED"] = "UNMAPPED";
})(AddressTypeCode || (exports.AddressTypeCode = AddressTypeCode = {}));
var LegalPrivateCode;
(function (LegalPrivateCode) {
    LegalPrivateCode["LEGAL"] = "L";
    LegalPrivateCode["PRIVATE"] = "P";
})(LegalPrivateCode || (exports.LegalPrivateCode = LegalPrivateCode = {}));
var MarketingConsent;
(function (MarketingConsent) {
    MarketingConsent["YES"] = "YES";
    MarketingConsent["NO"] = "NO";
})(MarketingConsent || (exports.MarketingConsent = MarketingConsent = {}));
var IdentificationMethod;
(function (IdentificationMethod) {
    IdentificationMethod["FaceToFace"] = "FACE_TO_FACE";
    IdentificationMethod["FaceToFace3rd"] = "FACE_TO_FACE_3RD";
    IdentificationMethod["Distance"] = "DISTANCE";
    IdentificationMethod["Distance3rd"] = "DISTANCE_3RD";
    IdentificationMethod["VideoDirectly"] = "VIDEO_DIRECTLY";
    IdentificationMethod["Video3rd"] = "VIDEO_3RD";
    IdentificationMethod["Unidentified"] = "UNIDENTIFIED";
})(IdentificationMethod || (exports.IdentificationMethod = IdentificationMethod = {}));
var CustomerStatusCode;
(function (CustomerStatusCode) {
    CustomerStatusCode["PASSIVE"] = "PASSIVE";
    CustomerStatusCode["ACTIVE"] = "ACTIVE";
    CustomerStatusCode["UNIDENTIFIED"] = "UNIDENTIFIED";
    CustomerStatusCode["BANKRUPTCY"] = "BANKRUPTCY";
    CustomerStatusCode["DEAD"] = "DEAD";
})(CustomerStatusCode || (exports.CustomerStatusCode = CustomerStatusCode = {}));
var CommunicationChannelStatus;
(function (CommunicationChannelStatus) {
    CommunicationChannelStatus["DECLARED"] = "DECLARED";
    CommunicationChannelStatus["CONFIRMED"] = "CONFIRMED";
})(CommunicationChannelStatus || (exports.CommunicationChannelStatus = CommunicationChannelStatus = {}));
var CommunicationTypeCode;
(function (CommunicationTypeCode) {
    CommunicationTypeCode["EMAIL"] = "EMAIL";
    CommunicationTypeCode["MOBILE_MAIN"] = "MOBILE_MAIN";
    CommunicationTypeCode["MOBILE_SECOND"] = "MOBILE_SECOND";
    CommunicationTypeCode["PHONE_PRIVATE"] = "PHONE_PRIVATE";
    CommunicationTypeCode["PHONE_WORK"] = "PHONE_WORK";
    CommunicationTypeCode["PHONE_EMERGENCY"] = "PHONE_EMERGENCY";
    CommunicationTypeCode["PHONE_HOME"] = "PHONE_HOME";
})(CommunicationTypeCode || (exports.CommunicationTypeCode = CommunicationTypeCode = {}));
var SegmentGroupCode;
(function (SegmentGroupCode) {
    SegmentGroupCode["PEP"] = "PEP";
    SegmentGroupCode["BANK_EMPLOYEE"] = "BANK_EMPLOYEE";
    SegmentGroupCode["DEAD"] = "DEAD";
    SegmentGroupCode["BANKRUPTCY"] = "BANKRUPTCY";
    SegmentGroupCode["MANDATORY_MILITARY_SERVICE"] = "MANDATORY_MILITARY_SERVICE";
    SegmentGroupCode["LOYAL_CUSTOMER_LEVEL_ONE"] = "LOYAL_CUSTOMER_LEVEL_ONE";
    SegmentGroupCode["LOYAL_CUSTOMER_LEVEL_TWO"] = "LOYAL_CUSTOMER_LEVEL_TWO";
    SegmentGroupCode["BANK_GROUP_COMPANY"] = "BANK_GROUP_COMPANY";
    SegmentGroupCode["CUSTOMER_CONSENT"] = "CUSTOMER_CONSENT";
    SegmentGroupCode["DECLARED_PEP"] = "DECLARED_PEP";
    SegmentGroupCode["SUSPICIOUS_ACTIVITY"] = "SUSPICIOUS_ACTIVITY";
})(SegmentGroupCode || (exports.SegmentGroupCode = SegmentGroupCode = {}));
var ProceedingTypeCode;
(function (ProceedingTypeCode) {
    ProceedingTypeCode["BailiffProceeding"] = "BAILIFF_PROCEEDING";
    ProceedingTypeCode["BankruptcyCase"] = "BANKRUPTCY_CASE";
    ProceedingTypeCode["CriminalCase"] = "CRIMINAL_CASE";
    ProceedingTypeCode["DeathCase"] = "DEATH_CASE";
})(ProceedingTypeCode || (exports.ProceedingTypeCode = ProceedingTypeCode = {}));
var ProceedingStatusCode;
(function (ProceedingStatusCode) {
    ProceedingStatusCode["Active"] = "ACTIVE";
    ProceedingStatusCode["Closed"] = "CLOSED";
})(ProceedingStatusCode || (exports.ProceedingStatusCode = ProceedingStatusCode = {}));
var RelationTypeCode;
(function (RelationTypeCode) {
    RelationTypeCode["Undefined"] = "UNDEFINED";
    RelationTypeCode["Acquaintance"] = "ACQUAINTANCE";
    RelationTypeCode["BankruptcyCase"] = "BANKRUPTCY_CASE";
    RelationTypeCode["Cohabit"] = "COHABIT";
    RelationTypeCode["CriminalCase"] = "CRIMINAL_CASE";
    RelationTypeCode["DeathCase"] = "DEATH_CASE";
    RelationTypeCode["Household"] = "HOUSEHOLD";
    RelationTypeCode["Representative"] = "REPRESENTATIVE";
    // Deprecated, use Representative
    RelationTypeCode["LegalGuardianRepresentative"] = "LEGAL_GUARDIAN_REPRESENTATIVE";
    RelationTypeCode["MemberManagementBoard"] = "MEMBER_MANAGEMENT_BOARD";
    RelationTypeCode["Other"] = "OTHER";
    RelationTypeCode["Relative"] = "RELATIVE";
    RelationTypeCode["ShareholderAssociate"] = "SHAREHOLDER_ASSOCIATE";
    RelationTypeCode["SupervisoryBoardMember"] = "SUPERVISORY_BOARD_MEMBER";
    RelationTypeCode["AccountBalanceNotificationRequester"] = "ACCOUNT_BALANCE_NOTIFICATION_REQUESTER";
    RelationTypeCode["TrusteeWitnessAttorney"] = "TRUSTEE_WITNESS_ATTORNEY";
    RelationTypeCode["Inheritor"] = "INHERITOR";
    RelationTypeCode["Spouse"] = "SPOUSE";
    RelationTypeCode["SuretyProvider"] = "SURETY_PROVIDER";
    RelationTypeCode["SecuredLoanOwner"] = "SECURED_LOAN_OWNER";
    RelationTypeCode["PowerOfAttorney"] = "POWER_OF_ATTORNEY";
    RelationTypeCode["Guarantor"] = "GUARANTOR";
    RelationTypeCode["CoBorrower"] = "CO_BORROWER";
    RelationTypeCode["Shareholder"] = "SHAREHOLDER";
    RelationTypeCode["Employee"] = "EMPLOYEE";
    RelationTypeCode["Bequeather"] = "BEQUEATHER";
    RelationTypeCode["Ceo"] = "CEO";
    RelationTypeCode["BeneficialOwner"] = "BENEFICIAL_OWNER";
    RelationTypeCode["CooperationPartner"] = "COOPERATION_PARTNER";
    RelationTypeCode["Employer"] = "EMPLOYER";
    RelationTypeCode["ConsolidationGroupMember"] = "CONSOLIDATION_GROUP_MEMBER";
    RelationTypeCode["ParentCompany"] = "PARENT_COMPANY";
    RelationTypeCode["Subsidiary"] = "SUBSIDIARY";
    RelationTypeCode["Procurator"] = "PROCURATOR";
    RelationTypeCode["CollateralProvider"] = "COLLATERAL_PROVIDER";
    RelationTypeCode["MemberOfACorporateGroup"] = "MEMBER_OF_A_CORPORATE_GROUP";
    RelationTypeCode["DelegatingAuthority"] = "DELEGATING_AUTHORITY";
    RelationTypeCode["ControlledEntity"] = "CONTROLLED_ENTITY";
    RelationTypeCode["ManagedEntity"] = "MANAGED_ENTITY";
})(RelationTypeCode || (exports.RelationTypeCode = RelationTypeCode = {}));
var ActivityCode;
(function (ActivityCode) {
    ActivityCode["Conscript"] = "CONSCRIPT";
    ActivityCode["Employee"] = "EMPLOYEE";
    ActivityCode["Entrepreneur"] = "ENTREPRENEUR";
    ActivityCode["Freelancer"] = "FREELANCER";
    ActivityCode["IndividualActivity"] = "INDIVIDUAL_ACTIVITY";
    ActivityCode["Other"] = "OTHER";
    ActivityCode["OtherActivity"] = "OTHER_ACTIVITY";
    ActivityCode["ParentalLeave"] = "PARENTAL_LEAVE";
    ActivityCode["Pensioner"] = "PENSIONER";
    ActivityCode["PrivateSector"] = "PRIVATE_SECTOR";
    ActivityCode["PublicSector"] = "PUBLIC_SECTOR";
    ActivityCode["Retired"] = "RETIRED";
    ActivityCode["Student"] = "STUDENT";
    ActivityCode["Unemployed"] = "UNEMPLOYED";
})(ActivityCode || (exports.ActivityCode = ActivityCode = {}));
var IdDocumentStatusCode;
(function (IdDocumentStatusCode) {
    IdDocumentStatusCode["WaitingAcceptance"] = "WAITING_ACCEPTANCE";
    IdDocumentStatusCode["Valid"] = "VALID";
    IdDocumentStatusCode["Invalid"] = "INVALID";
})(IdDocumentStatusCode || (exports.IdDocumentStatusCode = IdDocumentStatusCode = {}));
var IdDocumentTypeCode;
(function (IdDocumentTypeCode) {
    IdDocumentTypeCode["Passport"] = "PASSPORT";
    IdDocumentTypeCode["IdCard"] = "ID_CARD";
    IdDocumentTypeCode["TemporaryResidencePermitCard"] = "TEMPORARY_RESIDENCE_PERMIT_CARD";
    IdDocumentTypeCode["PermanentResidencePermitCard"] = "PERMANENT_RESIDENCE_PERMIT_CARD";
    IdDocumentTypeCode["EuResidencePermitCard"] = "EU_RESIDENCE_PERMIT_CARD";
    IdDocumentTypeCode["AliensPassport"] = "ALIENS_PASSPORT";
    /** Deprecated, use DriversLicense */
    IdDocumentTypeCode["DriveLicense"] = "DRIVE_LICENSE";
    IdDocumentTypeCode["DriversLicense"] = "DRIVERS_LICENSE";
    IdDocumentTypeCode["DiplomaticPassport"] = "DIPLOMATIC_PASSPORT";
    IdDocumentTypeCode["ForeignPassport"] = "FOREIGN_PASSPORT";
    IdDocumentTypeCode["RegistrationCertificate"] = "REGISTRATION_CERTIFICATE";
    IdDocumentTypeCode["BirthCertificate"] = "BIRTH_CERTIFICATE";
    IdDocumentTypeCode["Other"] = "OTHER";
    IdDocumentTypeCode["Unmapped"] = "UNMAPPED";
})(IdDocumentTypeCode || (exports.IdDocumentTypeCode = IdDocumentTypeCode = {}));
var LegalCustomerDocumentTypeCode;
(function (LegalCustomerDocumentTypeCode) {
    LegalCustomerDocumentTypeCode["FinancialDocumentation"] = "FINANCIAL_DOCUMENTATION";
    LegalCustomerDocumentTypeCode["LegalDocumentation"] = "LEGAL_DOCUMENTATION";
    LegalCustomerDocumentTypeCode["RequestsKycDocuments"] = "REQUESTS_KYC_DOCUMENTS";
    LegalCustomerDocumentTypeCode["CompanyInformation"] = "COMPANY_INFORMATION";
    LegalCustomerDocumentTypeCode["ExternalRegistryInquiry"] = "EXTERNAL_REGISTRY_INQUIRY";
    LegalCustomerDocumentTypeCode["MiscScanned"] = "MISC_SCANNED";
    LegalCustomerDocumentTypeCode["CustomerDataSheet"] = "CUSTOMER_DATA_SHEET";
    LegalCustomerDocumentTypeCode["SofSowForm"] = "SOF_SOW_FORM";
    LegalCustomerDocumentTypeCode["CommercialRegister"] = "COMMERCIAL_REGISTER";
    LegalCustomerDocumentTypeCode["CreditInfo"] = "CREDIT_INFO";
    LegalCustomerDocumentTypeCode["ArticlesOfAssociation"] = "ARTICLES_OF_ASSOCIATION";
    LegalCustomerDocumentTypeCode["BackgroundCheckForm"] = "BACKGROUND_CHECK_FORM";
    LegalCustomerDocumentTypeCode["BusinessActivityReview"] = "BUSINESS_ACTIVITY_REVIEW";
    LegalCustomerDocumentTypeCode["PersonalDataSheet"] = "PERSONAL_DATA_SHEET";
    LegalCustomerDocumentTypeCode["PowerOfAttorney"] = "POWER_OF_ATTORNEY";
    LegalCustomerDocumentTypeCode["Unmapped"] = "UNMAPPED";
})(LegalCustomerDocumentTypeCode || (exports.LegalCustomerDocumentTypeCode = LegalCustomerDocumentTypeCode = {}));
var CompanyLegalFormEE;
(function (CompanyLegalFormEE) {
    CompanyLegalFormEE["EE101"] = "AS";
    CompanyLegalFormEE["EE102"] = "O\u00DC";
    CompanyLegalFormEE["EE201"] = "T\u00DC";
    CompanyLegalFormEE["EE202"] = "U\u00DC";
    CompanyLegalFormEE["EE203"] = "MT\u00DC";
    CompanyLegalFormEE["EE204"] = "Tu\u00DC";
    CompanyLegalFormEE["EE205"] = "SA";
    CompanyLegalFormEE["EE206"] = "RKOA";
    CompanyLegalFormEE["EE207"] = "K\u00DC";
    CompanyLegalFormEE["EE208"] = "AOJ";
})(CompanyLegalFormEE || (exports.CompanyLegalFormEE = CompanyLegalFormEE = {}));
var CompanyLegalFormLV;
(function (CompanyLegalFormLV) {
    CompanyLegalFormLV["LV101"] = "AS";
    CompanyLegalFormLV["LV103"] = "SIA";
    CompanyLegalFormLV["LV104"] = "VU";
    CompanyLegalFormLV["LV105"] = "PSV";
    CompanyLegalFormLV["LV106"] = "UZN";
    CompanyLegalFormLV["LV107"] = "PS";
    CompanyLegalFormLV["LV108"] = "KS";
    CompanyLegalFormLV["LV109"] = "LIG";
    CompanyLegalFormLV["LV110"] = "PAJ";
    CompanyLegalFormLV["LV111"] = "PAP";
    CompanyLegalFormLV["LV301"] = "GIM";
    CompanyLegalFormLV["LV302"] = "IK";
    CompanyLegalFormLV["LV303"] = "IND";
    CompanyLegalFormLV["LV401"] = "KB";
    CompanyLegalFormLV["LV402"] = "KBS";
    CompanyLegalFormLV["LV403"] = "KBU";
    CompanyLegalFormLV["LV404"] = "KSS";
    CompanyLegalFormLV["LV405"] = "ZEM";
    CompanyLegalFormLV["LV406"] = "ZVJ";
    CompanyLegalFormLV["LV701"] = "PPI";
    CompanyLegalFormLV["LV801"] = "REL";
    CompanyLegalFormLV["LV802"] = "SOU";
    CompanyLegalFormLV["LV803"] = "ARA";
    CompanyLegalFormLV["LV804"] = "ARB";
    CompanyLegalFormLV["LV805"] = "ARV";
    CompanyLegalFormLV["LV806"] = "ROROIG";
    CompanyLegalFormLV["LV807"] = "BDR";
    CompanyLegalFormLV["LV808"] = "NOD";
    CompanyLegalFormLV["LV809"] = "PP";
    CompanyLegalFormLV["LV810"] = "PPA";
    CompanyLegalFormLV["LV903"] = "PAR";
})(CompanyLegalFormLV || (exports.CompanyLegalFormLV = CompanyLegalFormLV = {}));
var CompanyLegalFormLT;
(function (CompanyLegalFormLT) {
    CompanyLegalFormLT["LT101"] = "AB";
    CompanyLegalFormLT["LT102"] = "UAB";
    CompanyLegalFormLT["LT103"] = "KO";
    CompanyLegalFormLT["LT104"] = "TUB";
    CompanyLegalFormLT["LT105"] = "KUB";
    CompanyLegalFormLT["LT106"] = "A";
    CompanyLegalFormLT["LT107"] = "MB";
    CompanyLegalFormLT["LT108"] = "ZUB";
    CompanyLegalFormLT["LT109"] = "II";
    CompanyLegalFormLT["LT110"] = "APB";
    CompanyLegalFormLT["LT111"] = "PDB";
    CompanyLegalFormLT["LT201"] = "VI";
    CompanyLegalFormLT["LT202"] = "SI";
    CompanyLegalFormLT["LT203"] = "VS";
    CompanyLegalFormLT["LT204"] = "BI";
    CompanyLegalFormLT["LT205"] = "LF";
    CompanyLegalFormLT["LT206"] = "BN";
    CompanyLegalFormLT["LT207"] = "SD";
    CompanyLegalFormLT["LT208"] = "PP";
    CompanyLegalFormLT["LT209"] = "TR";
    CompanyLegalFormLT["LT210"] = "RB";
    CompanyLegalFormLT["LT211"] = "PS";
    CompanyLegalFormLT["LT212"] = "NA";
    CompanyLegalFormLT["LT213"] = "S";
    CompanyLegalFormLT["LT214"] = "PR";
    CompanyLegalFormLT["LT215"] = "LPRA";
    CompanyLegalFormLT["LT216"] = "CRC";
    CompanyLegalFormLT["LT301"] = "CB";
})(CompanyLegalFormLT || (exports.CompanyLegalFormLT = CompanyLegalFormLT = {}));
/**
 * @url: https://confluence.big.local/display/GLOSSARY/Education
 */
var Education;
(function (Education) {
    Education["Basic"] = "BASIC";
    Education["SecondarySpecialised"] = "SECONDARY_SPECIALISED";
    Education["Secondary"] = "SECONDARY";
    Education["Higher"] = "HIGHER";
    Education["HigherBA"] = "HIGHER_BA";
    Education["HigherMA"] = "HIGHER_MA";
    Education["HigherPHD"] = "HIGHER_PHD";
})(Education || (exports.Education = Education = {}));
var Activity;
(function (Activity) {
    Activity["Worker"] = "WORKER";
    Activity["Specialist"] = "SPECIALIST";
    Activity["SeniorSpecialist"] = "SENIOR_SPECIALIST";
    Activity["TeamLead"] = "TEAM_LEAD";
    Activity["MiddleManager"] = "MIDDLE_MANAGER";
    Activity["SeniorManager"] = "SENIOR_MANAGER";
})(Activity || (exports.Activity = Activity = {}));
/**
 * @url: https://confluence.big.local/display/GLOSSARY/Income+type
 */
var IncomeType;
(function (IncomeType) {
    IncomeType["Salary"] = "SALARY";
    IncomeType["ParentalBenefit"] = "PARENTAL_BENEFIT";
    IncomeType["ChildBenefit"] = "CHILD_BENEFIT";
    IncomeType["Alimony"] = "ALIMONY";
    IncomeType["SocialBenefit"] = "SOCIAL_BENEFIT";
    IncomeType["SicknessBenefit"] = "SICKNESS_BENEFIT";
    IncomeType["Pension"] = "PENSION";
    IncomeType["RetirementPension"] = "RETIREMENT_PENSION";
    IncomeType["DisabilityPension"] = "DISABILITY_PENSION";
    IncomeType["BusinessIncome"] = "BUSINESS";
    IncomeType["Dividends"] = "DIVIDENDS";
    IncomeType["Rent"] = "RENT";
    IncomeType["DailyAllowances"] = "DAILY_ALLOWANCES";
    IncomeType["ChildcareAllowance"] = "CHILDCARE_ALLOWANCE";
    IncomeType["Savings"] = "SAVINGS";
    IncomeType["FriendsFamily"] = "FRIENDS_FAMILY";
    IncomeType["Other"] = "OTHER";
})(IncomeType || (exports.IncomeType = IncomeType = {}));
var PurposeOfRelationShip;
(function (PurposeOfRelationShip) {
    PurposeOfRelationShip["EveryDayBanking"] = "EVERYDAY_BANKING";
    PurposeOfRelationShip["Loan"] = "LOAN";
    PurposeOfRelationShip["Saving"] = "SAVING";
    PurposeOfRelationShip["Deposits"] = "DEPOSITS";
})(PurposeOfRelationShip || (exports.PurposeOfRelationShip = PurposeOfRelationShip = {}));
var PlannedMonthlyTurnover;
(function (PlannedMonthlyTurnover) {
    PlannedMonthlyTurnover["0_1000"] = "[0,1000]";
    PlannedMonthlyTurnover["1001_2500"] = "[1001,2500]";
    PlannedMonthlyTurnover["2501_5000"] = "[2501,5000]";
    PlannedMonthlyTurnover["5001_15000"] = "[5001,15000]";
    PlannedMonthlyTurnover["MORE_THAN_15000"] = "[15000,)";
})(PlannedMonthlyTurnover || (exports.PlannedMonthlyTurnover = PlannedMonthlyTurnover = {}));
var LegalCapacity;
(function (LegalCapacity) {
    LegalCapacity["DISABLED"] = "DISABLED";
    LegalCapacity["RESTRICTED_NO_VOTING_RIGHTS"] = "RESTRICTED_NO_VOTING_RIGHTS";
    LegalCapacity["RESTRICTED_WITH_VOTING_RIGHTS"] = "RESTRICTED_WITH_VOTING_RIGHTS";
})(LegalCapacity || (exports.LegalCapacity = LegalCapacity = {}));
